import * as z from "zod";

export const addLinearCommentReaction = {
  name: "addLinearCommentReaction" as const,
  input: z.object({
    linearTicketId: z.string(),
    commentId: z.string(),
    emoji: z.string(),
  }),
  output: z.object({ success: z.boolean(), slackSuccess: z.boolean() }),
};
